import React from "react";
import styled from "styled-components";
import accountIMG from '../../images/account.svg'
import {getImage} from "../../utils/utils";

const RightLabel = ({pilot}) => {
    return (
        <Container>
            {pilot &&
            <>
                <Img src={getImage(pilot.photo, accountIMG)} alt={pilot.firstName + " " + pilot.lastName}/>
                <p> {pilot?.firstName} {pilot.lastName}</p>
            </>

            }
        </Container>
    )
}
const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`

const Img = styled.img`
  height: 35px;
  width: 35px;
  border-radius: 50%;
  object-fit: cover;
  border: 1px solid var(--color-grey);
`
export default RightLabel